module.exports = __webpack_public_path__ + "static/media/guia-de-hoy-32x48.a4973e65.svg";